import http from "../../http";

const purchase = {

    savePurchase(r) {
        return http.payload("/gateway/api/sycompany/pc/PurchasePC/savePurchase", r)
    },
    selectPurchaseById(r) {
        return http.get("/gateway/api/sycompany/pc/PurchasePC/selectPurchaseById", r)
    },
    deletePurchaseById(r) {
        return http.post("/gateway/api/sycompany/pc/PurchasePC/deletePurchaseById", r)
    },
    selectPurchasePage(r) {
        return http.spin.get("/gateway/api/sycompany/pc/PurchasePC/selectPurchasePage", r)
    },
    selectPurchaseGoodsList(r) {
        return http.spin.get("/gateway/api/sycompany/pc/PurchasePC/selectPurchaseGoodsList", r)
    },
    savePurchaseGoods(r) {
        return http.confirm.payload("/gateway/api/sycompany/pc/PurchasePC/savePurchaseGoods", r)
    },
    deletePurchaseGoods(r) {
        return http.confirm.post("/gateway/api/sycompany/pc/PurchasePC/deletePurchaseGoods", r)
    },

}
export default purchase
